module.exports = __webpack_public_path__ + "img/flyvr.d0ad8997.jpg";